import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { RMA_DEFAULT_HTTP_OPTIONS } from '@rma/dashboard/generic/util/environment';
import { ProfileType } from '@rma/generic/domain/types';
import { appendToRmaReviewsApiUrl } from '@rma/generic/ng/util';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PotentialReviewsApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly reviewsApiUrl = inject(appendToRmaReviewsApiUrl);

  public getPotentialRealterGoogleReviewCount(profileCode: string, profileType: ProfileType): Observable<number> {
    return this.httpClient.get<number>(
      this.reviewsApiUrl(`${profileType}/${profileCode}/PotentialSalesGoogleAndRealtorReviewsCount`),
      RMA_DEFAULT_HTTP_OPTIONS,
    );
  }
}
